import { COMMENT_AND_TAGS_UPDATE_ASYNC, MODAL_CLOSE, MODAL_OPEN } from './constants'

export function openChangedStateModal(params) {
  return (dispatch) =>
    dispatch({
      type: MODAL_OPEN,
      data: { ...params },
    })
}

function closeModal() {
  return (dispatch) =>
    dispatch({
      type: MODAL_CLOSE,
      data: null,
    })
}

const saveCommentAndTags = (
  reportId,
  reportType,
  comment,
  isSharedComment,
  tags,
  reportState,
  communityUser
) => ({
  type: COMMENT_AND_TAGS_UPDATE_ASYNC.INITIATE,
  payload: {
    reportId,
    reportType,
    comment,
    isSharedComment,
    tags,
    reportState,
    communityUser,
  },
})
export const saveCommentAndTagsSuccess = (response, reportId, reportType, reportState) => ({
  type: COMMENT_AND_TAGS_UPDATE_ASYNC.SUCCESS,
  payload: {
    response,
    reportId,
    reportType,
    reportState,
  },
})
export const saveCommentAndTagsError = (error) => ({
  type: COMMENT_AND_TAGS_UPDATE_ASYNC.ERROR,
  error,
})
const saveCommentAndTagsCancel = () => ({
  type: COMMENT_AND_TAGS_UPDATE_ASYNC.CANCEL,
})

export default {
  openChangedStateModal,
  closeModal,
  saveCommentAndTags,
  saveCommentAndTagsCancel,
}
